import { useParams } from "react-router-dom";

const LAST_ORG_KEY = "pf-last-org";

export function useOrgId() {
  const { orgId } = useParams<{ orgId: string }>();
  if (!orgId) throw new Error("useOrgId used outside an organization route");

  return orgId;
}

export function rememberOrg(orgId: string) {
  try {
    localStorage.setItem(LAST_ORG_KEY, orgId);
  } catch {
    // storage may be unavailable (private mode)
  }
}

export function lastOrg(): string | null {
  try {
    return localStorage.getItem(LAST_ORG_KEY);
  } catch {
    return null;
  }
}
